import React from "react";
import { Skeleton } from "@/components/ui/skeleton";
import { useUnitItemContext } from "@/hooks/useUnitItemContext";

interface UnitImageProps {
    length: number;
    width: number;
    className?: string;
}

export const UnitImage = ({ length, width, className }: UnitImageProps) => {
    const [imageError, setImageError] = React.useState(false);
    const [imageLoaded, setImageLoaded] = React.useState(false);
    const { unitGroup } = useUnitItemContext();

    const category = unitGroup.representative_unit.category;

    // Determine image source: use category image if available, otherwise construct path from dimensions
    const imageSrc =
        category.image || `/src/assets/icons/${width}x${length}.svg`;

    const handleImageLoad = () => {
        setImageLoaded(true);
        setImageError(false);
    };

    const handleImageError = () => {
        setImageError(true);
        setImageLoaded(false);
        console.warn(`Failed to load image: ${imageSrc}`);
    };

    if (imageError) {
        // Show skeleton if image fails to load
        return <Skeleton className="tw:h-[75px] tw:w-[75px]" />;
    }

    return (
        <>
            {!imageLoaded && <Skeleton className="tw:h-[75px] tw:w-[75px]" />}
            <img
                src={imageSrc}
                alt={`${width}x${length} storage unit`}
                className={className}
                onLoad={handleImageLoad}
                onError={handleImageError}
                style={{ display: imageLoaded ? "block" : "none" }}
            />
        </>
    );
};
